import React, { useEffect, useState } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import { Cookies } from "react-cookie";
import guidePdf from "../../sample/customs_clearance_platform.pdf";

const cookies = new Cookies();
const HIDE_COOKIE_KEY = "hide_customs_clearance_notice";
const HIDE_DAYS = 7;

function CustomsClearanceNoticeModal({ active, onDone }) {
  const [isOpen, setIsOpen] = useState(false);
  const [eligible, setEligible] = useState(null);

  useEffect(() => {
    const isEligible = !cookies.get(HIDE_COOKIE_KEY);
    setEligible(isEligible);
    if (!isEligible) onDone();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (eligible && active) setIsOpen(true);
  }, [eligible, active]);

  const finish = () => {
    setIsOpen(false);
    onDone();
  };

  const handleHideForWeek = () => {
    const expires = new Date();
    expires.setDate(expires.getDate() + HIDE_DAYS);
    cookies.set(HIDE_COOKIE_KEY, "true", { path: "/", expires });
    finish();
  };

  return (
    <Modal isOpen={isOpen} toggle={finish} centered size="md" scrollable>
      <ModalBody className="p-4">
        <h5 className="fw-bold text-center mb-3">
          전자상거래전용통관플랫폼 안내
        </h5>
        <p>
          안녕하세요.
          <br />
          해외구매대행 상품을 국내 온라인몰(스마트스토어 등)에서 판매하시는
          업체는 관세청 <b>전자상거래업자 부호</b>를 발급받아 판매채널에
          등록하셔야 합니다.
        </p>
        <ol className="mb-3 ps-3">
          <li className="mb-2">
            <b>전자상거래업자 부호 발급</b>
            <br />
            UNI-PASS 업체 회원 가입 후 관세청 전자상거래업자 누리집
            (unipass.customs.go.kr/ecb)에서 9자리 부호를 발급받습니다.
            <br />
            <small className="text-muted">
              처리기간 접수일로부터 10일 · 유효기간 3년
            </small>
          </li>
          <li className="mb-2">
            <b>판매채널별 부호 등록 및 적용</b>
            <br />
            스마트스토어 등 판매채널에 부호를 등록하고 해외구매대행 상품에
            적용합니다.
          </li>
          <li>
            <b>메가몰 주문서 추가 입력 정보</b>
            <br />
            '플랫폼 신고' 여부(Y/N), 전자상거래업자 부호 등 필수값과
            신고단가(USD)가 주문서에 추가될 예정입니다.
          </li>
        </ol>
        <div className="p-3 mb-3 rounded bg-light small">
          ※ 주문의 총 신고가격이 <b>US$150를 초과하면 관세가 부과</b>됩니다.
          <br />※ 주문서 항목은 메가몰 시스템 업데이트 전 사전 안내로, 적용
          시점에 변경될 수 있습니다.
        </div>
        <p className="mb-3">
          처리기간이 소요되니 <b>미리 부호를 신청</b>해 주시기 바랍니다.
          자세한 내용은 아래 안내 가이드를 확인해 주세요.
        </p>
        <div className="text-center">
          <Button
            color="primary"
            outline
            tag="a"
            href={guidePdf}
            target="_blank"
            rel="noopener noreferrer"
          >
            안내 가이드(PDF) 보기
          </Button>
        </div>
      </ModalBody>
      <div className="d-flex border-top">
        <Button
          color="light"
          className="w-50 rounded-0"
          onClick={handleHideForWeek}
        >
          일주일동안 안보이기
        </Button>
        <Button color="dark" className="w-50 rounded-0" onClick={finish}>
          닫기
        </Button>
      </div>
    </Modal>
  );
}

export default CustomsClearanceNoticeModal;
